/* 🤖 this file was generated by svg-to-ts */
export const matIconJavascript: {
  name: 'javascript';
  data: string;
} = {
  name: 'javascript',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 14v-1h1.5v.5h2v-1H13c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1H16c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zM9 9v4.5H7.5v-1H6v1c0 .83.67 1.5 1.5 1.5H9c.83 0 1.5-.67 1.5-1.5V9H9z"/></svg>`
};
